import React from 'react'
import axios from "axios";
import SglContext from "../SglContext";
import './badEmailForm.css'
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";

//API END POINTS
// const sgl_webservice_post_send_verification_email = Sgl.sglApiUrl+'/iphone.php/webservice/PostSendVerificationEmail';
// const sgl_webservice_send_verification_email = Sgl.sglApiUrl+'/iphone.php/webservice/SendVerificationEmail';
//const auth_url = api_base_url+'/auth/login';

class BadEmailForm extends React.Component {
    get sgl_webservice_post_send_verification_email() {
      return this.context.sglApiUrl + '/iphone.php/webservice/PostSendVerificationEmail';
    }

    get sgl_webservice_send_verification_email() {
      return this.context.sglApiUrl + '/iphone.php/webservice/SendVerificationEmail';
    }    

    state = {
        loading: true,
        company_name: '',
        bad_email_count: 0,
        sent_on_email: '',
        loginid: 0,
        secret: ''
    }

    constructor(props) {
      super();
      // bind function in constructor instead of render
      this.processSendEmailVerification = this.processSendEmailVerification.bind(this);
    }

    componentDidMount() {
        // this.checkUserSession();
        this.setState({
          loginid: this.props.searchParams.get('loginid'),
          secret: this.props.searchParams.get('secret'),
        },() => {
          this.getAllDataForBadEmailForm();    
        })
  
    }
 
    getAllDataForBadEmailForm(){
      axios.get(this.sgl_webservice_send_verification_email, {
        params : {
            customer_id: this.context.company_id,
            loginid: this.state.loginid,
            secret: this.state.secret
        }
      })
      .then((response) => {    
        this.setState({
          company_name : response.data.company_name,
          loading: false,
          bad_email_count: response.data.bad_email_count
        });

        if(!response.data.status){
          let sgl_plugin_error_message = document.getElementById('sgl-plugin-error-message');
          let sgl_plugin_form = document.getElementById('sgl-plugin-form');
          sgl_plugin_error_message.innerHTML = response.data.error_msg;
          sgl_plugin_error_message.style.display = "block";
          sgl_plugin_form.style.display = "none";
        }

      });
    }

    verify = () => {
      this.processSendEmailVerification("Verify");
    }

    changeEmail = () => {
      this.processSendEmailVerification("changeEmail");
    }

    processSendEmailVerification = (form_action) => {
      let email = document.getElementById('email');
      let current_login_email = document.getElementById('current_login_email');
      let new_login_email = document.getElementById('new_login_email');
      let confirm_email = document.getElementById('confirm_email');
      let pass = document.getElementById('pass');

      let sgl_plugin_form = document.getElementById('sgl-plugin-form');
      let sgl_plugin_success_message = document.getElementById('sgl-plugin-success-message');
      let errorContainer_top = document.getElementById('error_summary_top');
      let errorContainer_bottom = document.getElementById('error_summary_bottom');

      errorContainer_top.innerHTML = "";
      errorContainer_top.style.display = "none";
      errorContainer_bottom.innerHTML = "";
      errorContainer_bottom.style.display = "none";

      axios.post(this.sgl_webservice_post_send_verification_email, null, { params: {
          email: email.value,
          pass: pass.value,
          current_login_email: current_login_email.value,
          new_login_email: new_login_email.value,
          confirm_email: confirm_email.value,
          form_action: form_action,
          loginid: this.state.loginid,
          secret: this.state.secret,
          customer_id: this.context.company_id,
          site_url: `${window.location.protocol}//${window.location.host}${(this.context.basePath != '/' && this.context.basePath != '')?`${this.context.basePath}`:""}`,
      }})
      .then((response) => {

        if(response.data.success){

          this.setState({ sent_on_email: response.data.sent_on_email });
          sgl_plugin_form.innerHTML = "";
          sgl_plugin_form.style.display = "none";
          sgl_plugin_success_message.style.display = "block";

        }else{

          if(response.data.terminate_process){

            errorContainer_top.innerHTML = "Processing error occurred.";
            errorContainer_top.style.display = "block";
            errorContainer_bottom.innerHTML = "Processing error occurred.";
            errorContainer_bottom.style.display = "block";
  
          }else{

            let message_lines = "";
            for(let i=0;i<response.data.errors.length;i++){
              message_lines += response.data.errors[i]+"<br/>";
            }
            errorContainer_top.innerHTML = message_lines;
            errorContainer_top.style.display = "block";
            errorContainer_bottom.innerHTML = message_lines;
            errorContainer_bottom.style.display = "block";

          }

        }
        
      });
    }


    render(){
      const loading = this.state.loading;
      const company_name = this.state.company_name;
      const bad_email_count = this.state.bad_email_count;
      const sent_on_email = this.state.sent_on_email;

      let message = "";
      if(bad_email_count > 0){
        message = "We have been unable to deliver the last "+bad_email_count+" emails to you.";
      }

      if(loading) {
        return null;
      }

      return(
        <div class="sgl-plugin">

          <div class="bad_email_header">
              <h1>{company_name} - VERIFY EMAIL</h1>
          </div>
          <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
          <br />
          <div id="sgl-plugin-form">  
            {/* form start */}
            <div class="div-responsive">
              <div class="bad-email-container">
                  <div class="error_container">
                    <div>
                        <p class="error_summary" id="error_summary_top"></p>
                    </div>
                  </div>

                  <div class="message">
                    <p>Alert: The email address that you have used to login does not appear to be valid any longer.<br/>
                    <b>{message}</b><br/>
                    Please choose one of the options below to re-activate your account. YOU WILL NOT BE ABLE TO LOGIN until this is completed.</p>
                  </div>

                  <div id="option_1">
                    <div class="message">
                      <p>
                        <b>Option 1 - Reverify your current email address.</b><br/><br/>
                        If your current email address was having temporary issues you may enter that address below to reverify that address and re-activate your login.<br/>
                        Please enter your email address below and click "Verify". You will receive an email with a link you must click in order to complete the process.
                      </p>
                    </div>
                    
                    <div class="full">
                        <input type="text" placeholder="Email" name="email" id="email" />
                    </div>

                    <div class="full submit">
                        <input type="button" id="verify" class="button" value="Verify" onClick={this.verify}/>
                    </div>
                  </div>
                  

                  <div id="option_2">
                    <div class="message">
                      <p>
                        <b>Option 2 - Provide a new email address.</b><br/><br/>
                        This will become your login once this process is complete.<br/>
                        Please enter your email address below and click "Change Email". You will receive an email with a link you must click in order to complete the process.
                      </p>
                    </div>

                    <div class="full">
                        <input type="text" placeholder="Current Login Email" name="current_login_email" id="current_login_email" /><br/>
                        <span>This is the email address that you have been using for logging in. This is the one we need to replace.</span>
                    </div>

                    <div class="full">
                        <input type="password" placeholder="Password" name="pass" id="pass" />
                    </div>

                    <div class="full">
                        <input type="text" placeholder="New Login Email" name="new_login_email" id="new_login_email" />
                    </div>

                    <div class="full">
                        <input type="text" placeholder="Confirm Email" name="confirm_email" id="confirm_email" />
                    </div>

                    <div class="full submit">
                        <input type="button" id="change_email" class="button" value="Change Email" onClick={this.changeEmail} />
                    </div>
                  </div>

                  <div class="message">
                    <p>
                      IMPORTANT - You must click the link in the email sent to you in order to complete EITHER of the steps above. 
                    </p>
                  </div>

                  <div class="error_container">
                      <div>
                          <p class="error_summary" id="error_summary_bottom"></p>
                      </div>
                  </div>
              </div>

            </div>
            {/* form end */}

          </div>

          <div id="sgl-plugin-error-message">
          </div>
          
          <div id='sgl-plugin-success-message'>
            <p>
              <b>Email Sent</b>
              <br />
              An email containing a link to verify your email address is sent to{" "}
              {sent_on_email}. Please check your email.
            </p>
          </div>

          <div className='copyright-text'>
            {process.env.REACT_APP_COPYRIGHT_TEXT}
          </div>

        </div>
      )
    }
  }

BadEmailForm.contextType = SglContext;
export default function (props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams()

  return <BadEmailForm {...props} navigate={navigate} searchParams={searchParams} />;
}